import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";

interface TenantCustomizationTabProps {
  tenant: {
    id: string;
    colors: any;
    images: any;
  };
}

export function TenantCustomizationTab({ tenant }: TenantCustomizationTabProps) {
  return (
    <div className="grid gap-4">
      <Card>
        <CardHeader>
          <CardTitle>Personalização</CardTitle>
          <CardDescription>Cores e imagens customizadas</CardDescription>
        </CardHeader>
        <CardContent className="space-y-6">
          {tenant.colors ? (
            <div>
              <p className="text-sm font-medium text-muted-foreground mb-4">Cores</p>
              <div className="space-y-4">
                {typeof tenant.colors === 'object' && tenant.colors !== null && (
                  <>
                    {(tenant.colors.dark || tenant.colors.light) && (
                      <div className="space-y-4">
                        <div className="flex items-center gap-4">
                          {tenant.colors.dark && (
                            <div className="flex-1">
                              <p className="text-xs font-semibold text-muted-foreground mb-2 uppercase">Tema Escuro</p>
                            </div>
                          )}
                          {tenant.colors.light && (
                            <div className="flex-1">
                              <p className="text-xs font-semibold text-muted-foreground mb-2 uppercase">Tema Claro</p>
                            </div>
                          )}
                        </div>
                        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                          {tenant.colors.dark && Object.entries(tenant.colors.dark).map(([key, value]) => (
                            <div key={`dark-${key}`} className="flex items-center gap-3">
                              <div
                                className="w-16 h-16 rounded-md border-2 border-border shadow-sm flex-shrink-0"
                                style={{ backgroundColor: value as string }}
                              />
                              <div>
                                <p className="text-sm font-medium capitalize">{key}</p>
                                <code className="text-xs text-muted-foreground">{value as string}</code>
                              </div>
                            </div>
                          ))}
                          {tenant.colors.light && Object.entries(tenant.colors.light).map(([key, value]) => (
                            <div key={`light-${key}`} className="flex items-center gap-3">
                              <div
                                className="w-16 h-16 rounded-md border-2 border-border shadow-sm flex-shrink-0"
                                style={{ backgroundColor: value as string }}
                              />
                              <div>
                                <p className="text-sm font-medium capitalize">{key}</p>
                                <code className="text-xs text-muted-foreground">{value as string}</code>
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    )}
                    {!tenant.colors.dark && !tenant.colors.light && (
                      <div className="grid grid-cols-2 gap-4">
                        {Object.entries(tenant.colors).map(([key, value]) => {
                          // Se o valor é uma cor válida (hex, rgb, etc)
                          if (typeof value === 'string' && (value.startsWith('#') || value.startsWith('rgb') || value.startsWith('hsl'))) {
                            return (
                              <div key={key} className="flex items-center gap-3">
                                <div
                                  className="w-16 h-16 rounded-md border-2 border-border shadow-sm flex-shrink-0"
                                  style={{ backgroundColor: value }}
                                />
                                <div>
                                  <p className="text-sm font-medium capitalize">{key}</p>
                                  <code className="text-xs text-muted-foreground">{value}</code>
                                </div>
                              </div>
                            );
                          }
                          return null;
                        })}
                      </div>
                    )}
                  </>
                )}
              </div>
            </div>
          ) : (
            <p className="text-sm text-muted-foreground">Nenhuma cor customizada</p>
          )}

          {tenant.images ? (
            <div>
              <p className="text-sm font-medium text-muted-foreground mb-4">Imagens</p>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                {typeof tenant.images === 'object' && tenant.images !== null && (
                  Object.entries(tenant.images).map(([key, value]) => {
                    if (typeof value === 'string' && value) {
                      return (
                        <div key={key} className="space-y-2">
                          <p className="text-sm font-medium capitalize">{key.replace(/_/g, ' ')}</p>
                          <div className="relative rounded-md overflow-hidden border-2 border-border bg-muted">
                            <img
                              src={value}
                              alt={key}
                              className="w-full h-auto max-h-48 object-contain"
                              onError={(e) => {
                                const target = e.target as HTMLImageElement;
                                target.style.display = 'none';
                                if (target.parentElement) {
                                  const errorDiv = document.createElement('div');
                                  errorDiv.className = 'p-4 text-center text-sm text-muted-foreground';
                                  errorDiv.textContent = 'Erro ao carregar imagem';
                                  target.parentElement.appendChild(errorDiv);
                                }
                              }}
                            />
                          </div>
                          <a
                            href={value}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-xs text-primary hover:underline block truncate"
                          >
                            {value}
                          </a>
                        </div>
                      );
                    }
                    return null;
                  })
                )}
              </div>
            </div>
          ) : (
            <p className="text-sm text-muted-foreground">Nenhuma imagem customizada</p>
          )}
        </CardContent>
      </Card>
    </div>
  );
}

